module.exports = __webpack_public_path__ + "img/no_data_news.f686cf7b.png";